import { BlogPost } from './types';
import { examStrategyPosts } from './exam-strategy';
import { technologyPosts } from './technology';
import { studyTipsPosts } from './study-tips';
import { productivityPosts } from './productivity';
import { subjectGuidePosts } from './subject-guide';

// Export types
export type { BlogPost };

// Aggregate all blog posts
export const blogPosts: BlogPost[] = [
  ...examStrategyPosts,
  ...technologyPosts,
  ...studyTipsPosts,
  ...productivityPosts,
  ...subjectGuidePosts
];

// Helper functions
export const getBlogPost = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};

export const getRelatedPosts = (currentSlug: string, category: string, limit: number = 3): BlogPost[] => {
  return blogPosts
    .filter(post => post.slug !== currentSlug && post.category === category)
    .slice(0, limit);
};

export const getCategories = (): string[] => {
  const categories = blogPosts.map(post => post.category);
  return Array.from(new Set(categories));
};

export const getRecentPosts = (limit: number = 5): BlogPost[] => {
  return blogPosts
    .sort((a, b) => new Date(b.publishedDate).getTime() - new Date(a.publishedDate).getTime())
    .slice(0, limit);
};

export const getPostsByCategory = (category: string): BlogPost[] => {
  return blogPosts.filter(post => post.category === category);
};
